import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetFeatures } from 'domains/Feature/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../OfferFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const FeatureFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [features] = useGetFeatures()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'features',
    operand: 'array-contains'
  })

  return (
    <StyledDetails
      open={localStorage.getItem(`feature-details-visibility`) === 'opened'}>
      <summary style={summaryStyles} onClick={() => onToggleDetails('feature')}>
        {t('Feature')}
      </summary>
      {features?.map((feature, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(feature)}
            onChange={() => onChange(feature)}>
            <Text wordBreak="break-all">
              {feature?.name || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

FeatureFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default FeatureFilter
